import React, { useState, useEffect } from 'react';
import { Select, Spin } from 'antd';
import { ShoppingOutlined } from '@ant-design/icons';
import productService from '../services/productService';
import { useAuth } from '../utils/auth';

const { Option } = Select;

const ProductSelector = ({ value, onChange, style, mode }) => {
  const { tenant } = useAuth();
  const tenantId = tenant?.id;
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (tenantId) fetchProducts();
  }, [tenantId]);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await productService.getActiveProducts(tenantId);
      if (response.success) setProducts(response.data || []);
    } catch (error) {
      console.error('获取商品列表失败:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Select
      placeholder={mode === 'multiple' ? '选择商品（可多选）' : '选择商品（可选）'}
      allowClear
      showSearch
      mode={mode || undefined}
      filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
      value={value}
      onChange={onChange}
      loading={loading}
      style={style}
      suffixIcon={<ShoppingOutlined />}
      notFoundContent={loading ? <Spin size="small" /> : '暂无商品'}
      maxTagCount="responsive"
    >
      {products.map(p => (
        <Option key={p.id} value={p.id}>
          {p.name}{p.price ? ` ¥${p.price}` : ''}
        </Option>
      ))}
    </Select>
  );
};

export default ProductSelector;
